import React from 'react';

import StoreCard from './StoreCard';
import { StoreWithManagers } from '../../ts/interfaces/stores/store';
import { OpsDivision } from '../../codegen/graphql';

type Props = Readonly<{
    stores: StoreWithManagers[];
    division: OpsDivision;
}>;

function Stores({ stores, division }: Props) {
    return stores.length ? (
        <div className="flex flex-col gap-2 mt-2">
            {stores.map(store => (
                <StoreCard key={store.id} store={store} division={division} />
            ))}
        </div>
    ) : (
        <div className="flex items-center justify-center h-12">
            <p className="font-medium">No Stores Found</p>
        </div>
    );
}

export default Stores;
